<template>
    <v-container>
        <!--  表单标题   -->
        <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218); height: 10px;" class="ml-4 mt-2">
            灭火器点检填报
            <v-icon></v-icon>
        </p>
        <v-icon></v-icon>
        <span class="ml-4" style="color:rgb(132, 132, 132); font-size: 12px;">根据消防点检情况进行填写</span>
        <div>
            <!-- 填报表单 -->
            <v-form ref="form" v-model="isValid">
                <v-card-text>
                    <v-row>
                        <!-- 点检设备类型 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备类型 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_type" label="请输入设备类型" :rules="requiredRules" required
                                hint="请输入设备类型"></v-text-field>
                        </v-col>
                        <!-- 点检设备数量 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;" class="mt-1">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备数量 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_number" label="请输入巡检设备数" type="number"
                                :rules="countRules" required hint="请输入同批次类型设备点检数量"></v-text-field>
                        </v-col>


                        <!-- 点检子项 -->
                        <v-col cols="12" class="mt-1">
                            <v-row>
                                <!-- 点检子项标题 -->
                                <v-col cols="12" class="d-flex align-center">
                                    <v-icon style="color:rgb(240,181,68);" size="20">mdi-book-edit</v-icon>
                                    <span style="font-size: 18px; font-weight: 700; color: rgb(240,181,68);"
                                        class="ml-2">
                                        检查内容项
                                    </span>
                                </v-col>
                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火箱</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_one" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="灭火箱：合格"></v-radio>
                                                <v-radio label="×" value="灭火箱：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火器瓶体</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_two" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="灭火器瓶体：合格"></v-radio>
                                                <v-radio label="×" value="灭火器瓶体：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火器铅封和保险销</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_three"
                                                :rules="requiredRadio" required row>
                                                <v-radio label="√" value="灭火器铅封和保险销：合格"></v-radio>
                                                <v-radio label="×" value="灭火器铅封和保险销：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="border: 1px rgb(188,188,189) solid; width: 100%;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火器喷管和喷嘴</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_four"
                                                :rules="requiredRadio" required row>
                                                <v-radio label="√" value="灭火器喷管和喷嘴：合格"></v-radio>
                                                <v-radio label="×" value="灭火器喷管和喷嘴：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>


                                <v-card style="width: 100%;" class="mt-1">
                                    <div style="width: 100%; border: 1px rgb(188,188,189) solid;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火器压把</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_five"
                                                :rules="requiredRadio" required row>
                                                <v-radio label="√" value="灭火器压把：合格"></v-radio>
                                                <v-radio label="×" value="灭火器压把：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>


                                <v-card style="width: 100%;" class="mt-1">
                                    <div style=" width: 100%; border: 1px rgb(188,188,189) solid;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火器压力</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_six" :rules="requiredRadio"
                                                required row>
                                                <v-radio label="√" value="灭火器压力：合格"></v-radio>
                                                <v-radio label="×" value="灭火器压力：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style=" width: 100%; border: 1px rgb(188,188,189) solid;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2">灭火器通道</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_seven"
                                                :rules="requiredRadio" required row>
                                                <v-radio label="√" value="灭火器通道：合格"></v-radio>
                                                <v-radio label="×" value="灭火器通道：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style=" width: 100%; border: 1px rgb(188,188,189) solid;"
                                        class="d-flex justify-space-between">
                                        <div cols="4" class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火器卫生</p>
                                        </div>
                                        <div cols="8" class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_eight"
                                                :rules="requiredRadio" required row>
                                                <v-radio label="√" value="灭火器卫生：合格"></v-radio>
                                                <v-radio label="×" value="灭火器卫生：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>

                                <v-card style="width: 100%;" class="mt-1">
                                    <div style=" width: 100%; border: 1px rgb(188,188,189) solid;"
                                        class="d-flex justify-space-between">
                                        <div class="d-flex align-center" style="height: 40px;">
                                            <p style="margin: 0;" class="ml-2"> 灭火器生产日期</p>
                                        </div>
                                        <div class="d-flex align-center" style="height: 40px;">
                                            <v-radio-group v-model="formData.check_task_item_nine"
                                                :rules="requiredRadio" required row>
                                                <v-radio label="√" value="灭火器生产日期：合格"></v-radio>
                                                <v-radio label="×" value="灭火器生产日期：不合格"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                </v-card>
                                <!-- 点检子项须知介绍 -->
                                <p class="mt-4 ml-2"> 维护检查须知：<br>
                                    ①灭火器不应放在潮湿、雨淋、暴晒、烘烤或者腐蚀性的环境里，灭火器箱的箱门开启应方便灵活，且不会阻挡灭火器的取用。灭火器应落实专人，每月至少检查一次，发现问题必须及时上报。<br>
                                    ②灭火器压力指针指到红色区，表示灭火器内压力小，不能有效喷出；指针指在绿区，表示压力正常，可以正常使用；
                                    指针指到黄色区属于压力偏高（瓶体耐压试验的压力是2.5MPa,若压力表指针超过2.5MPa时瓶体虽不一定爆炸，但危险性很大，不应继续使用
                                    ）；灭火器压力表的外表面不能有变形和损伤。<br>
                                    ③灭火器筒体是否有锈蚀、变形现象。锈蚀面积大于或等于筒体总面积四分之一以上，或连接部位、筒底严重锈蚀的属于报废器材。<br>
                                    ④保险销和铅封是否完好。⑤喷嘴是否有变形、开裂、损伤，喷射软管是否畅通、是否有变形和损伤。<br>
                                    ⑥压把、阀体等金属件是否有严重损伤、变形、锈蚀等影响使用的缺陷。<br>
                                    ⑦灭火器四周不应堆放杂物，应保持取用通道的畅通。<br>
                                    ⑧灭火器生产日期一般在合格证上，如合格证模糊可以参考灭火器压力表上的日期。<br>
                                <p class="ml-2">符合要求的项目请在所对应的框内打“√”，不符合的请打“×”，并在备注中注明具体情况。</p>
                                </p>
                            </v-row>
                        </v-col>
                        <!-- 设备点检反馈结果 -->
                        <v-col cols="12" class=""
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
                            <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px; padding: 0;">设备状态 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-radio-group v-model="formData.check_status" label="" :rules="requiredRules" required row
                                class="d-flex align-center">
                                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;"
                                    label="正常" value="正常"></v-radio>
                                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;"
                                    label="异常" value="异常"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <!-- 点检设备楼栋 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
                            class="mt-1">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">点检楼栋 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_buliding" label="请输入设备楼宇" :rules="requiredRules"
                                required hint="请输入设备楼宇"></v-text-field>
                        </v-col>

                        <!-- 点检设备楼层 -->
                        <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;"
                            pp class="mt-1">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">点检楼层 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_floor" label="请输入设备楼层" :rules="requiredRules" required
                                hint="请输入设备楼层"></v-text-field>
                        </v-col>

                        <!-- 点检设备描述 -->
                        <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">点检情况描述 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-textarea v-model="formData.check_description" label="设备异常情况说明" :rules="requiredRules"
                                required hint="设备异常情况说明"></v-textarea>
                        </v-col>


                        <!-- 上传现场图片 -->
                        <v-col cols="12" sm="6" md="4" class="mt-1"
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">上传附件 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-file-input v-model="check_attachment" label="上传现场图片" accept="image/*" required
                                hint="支持上传图片、PDF、Word文档" @change="uploadImage(check_attachment)"
                                :rules="[v => !!v || '请上传一张图片']">
                                <!-- @update:model-value="handleFileInput" -->
                            </v-file-input>
                            <v-img v-if="imageUrl" :src="imageUrl" aspect-ratio="1" class="mt-4"
                                max-width=""></v-img>
                        </v-col>


                        <!-- 巡检人员标题 -->
                        <v-col class="d-flex align-center float-left mt-4" style="height:40px;">
                            <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218);">
                                <v-icon style="color: rgb(50,134,218);">mdi-account-circle</v-icon>
                                巡检人员信息
                            </p>
                        </v-col>
                        <!-- 巡检人员 -->
                        <v-col cols="12" class=""
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">检查人员 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_staff" label="请输入检查人员" :rules="requiredRules" required
                                hint="请输入检查人员"></v-text-field>
                        </v-col>

                        <!-- 巡检部门 -->
                        <v-col cols="12" class="mt-1"
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
                            <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">检查部门 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_department" label="请输入检查部门/组" :rules="requiredRules"
                                required hint="请输入检查部门/组"></v-text-field>
                        </v-col>

                        <!-- 巡检时间 -->
                        <v-col cols="12" class="mt-1"
                            style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 123px;">
                            <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px;">检查时间 <p
                                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                            <v-text-field v-model="formData.check_date" label="" readonly
                                hint="自动填充当前时间"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-space-around">
                    <v-btn color="success" dark @click="resetForm">重置</v-btn>
                    <!-- <v-spacer></v-spacer>   -->
                    <v-btn color="blue darken-1" dark @click="submitForm">提交</v-btn>
                </v-card-actions>
            </v-form>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'fireExtinguisher',
    data() {
        return {
            isValid: false,                                     // 填报表单的状态
            formData: {
                check_id: '',                                   // 设备编号 
                check_type: '灭火器',                           // 点检设备类型
                check_number: '',                               // 点检类型设备数量
                check_task_item_one: '',                        // 设备点检子项(1项)
                check_task_item_two: '',                        // 设备点检子项(2项)
                check_task_item_three: '',                      // 设备点检子项(3项)
                check_task_item_four: '',                       // 设备点检子项(4项)
                check_task_item_five: '',                       // 设备点检子项(5项)
                check_task_item_six: '',                        // 设备点检子项(6项)
                check_task_item_seven: '',                      // 设备点检子项(7项)
                check_task_item_eight: '',                      // 设备点检子项(8项)
                check_task_item_nine: '',                       // 设备点检子项(9项)
                check_status: '',                               // 点检状态
                check_buliding: '',                             // 设备楼宇
                check_floor: '',                                // 设备楼层
                check_description: '',                          // 设备详情描述
                check_attachment: null,                         // 上传图片附件
                check_staff: '',                                // 巡检人员
                check_department: '',                           // 巡检部门
                check_date: '',                                 // 巡检时间
            },
            imageUrl: null,
            requiredRules: [v => !!v || '该字段是必填项'],       // 正则判断
            requiredRadio: [value => !!value || '该字段是必填项'],
            countRules: [v => !!v || '该字段是必填项', v => /^\d+$/.test(v) || '请输入有效的数字']

        }
    },
    // 初始化进入表单时读取当前系统时间进行传给表单填报时间
    mounted() {
        this.initializeTime();
    },
    // 此时 data 和 methods 属性初始化完成，页面（HTML）加载完成之前（未开始编译模板）调用此函数
    created() {

    },
    methods: {
        // 格式化时间
        async initializeTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            const day = now.getDate();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const seconds = now.getSeconds();
            const formattedMonth = month < 10 ? '0' + month : month.toString();
            const formattedDay = day < 10 ? '0' + day : day.toString();
            const formattedHours = hours < 10 ? '0' + hours : hours.toString();
            const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
            const formattedSeconds = seconds < 10 ? '0' + seconds : seconds.toString();
            const formattedDateTime = `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
            this.formData.check_date = formattedDateTime;
            return formattedDateTime;
        },

        async submitForm() {
            console.log('填报的数据信息', this.formData);
            if (this.isValid) {
                try {
                    await this.submitFormData();
                    this.showSucceSnackbar("填报成功。");
                } catch (error) {

                }

            }
        },
        // 拼接图片和字段文本内容直接提交
        async submitFormData() {
            try {
                // const imageUrl = await this.uploadImage(this.formData.abnormal_attachment);
                const textData = {
                    check_type: this.formData.check_type,
                    check_number: this.formData.check_number,
                    check_task_item_one: this.formData.check_task_item_one,
                    check_task_item_two: this.formData.check_task_item_two,
                    check_task_item_three: this.formData.check_task_item_three,
                    check_task_item_four: this.formData.check_task_item_four,
                    check_task_item_five: this.formData.check_task_item_five,
                    check_task_item_six: this.formData.check_task_item_six,
                    check_task_item_seven: this.formData.check_task_item_seven,
                    check_task_item_eight: this.formData.check_task_item_eight,
                    check_task_item_nine: this.formData.check_task_item_nine,
                    check_status: this.formData.check_status,
                    check_buliding: this.formData.check_buliding,
                    check_floor: this.formData.check_floor,
                    check_description: this.formData.check_description,
                    check_attachment: this.imageUrl,
                    check_staff: this.formData.check_staff,
                    check_department: this.formData.check_department,
                    check_date: this.formData.check_date,
                };
                console.log('拼接表单字段内容', textData);
                const jsonData = JSON.stringify(textData);

                console.log(jsonData);
                const response = await fetch('http://192.168.3.3:18081/check/addCheckExtinguisher', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: jsonData,
                });
                if (!response.ok) {
                    throw new Error("提交失败!");
                }
                console.log("提交成功!");
                this.$router.push("/logoView");


            } catch (error) {
                console.error('提交过程中发生错误：', error);
                this.showErrorSnackbar('提交失败，请检查网络或数据格式');
            }
        },


        // 上传图片,回传保存后的图片Url
        async uploadImage(check_attachment) {
            const formData = new FormData();
            const file = check_attachment;
            console.log("上传图片获取的地址", file)
            if (file) {
                formData.append('check_attachment', file);
            }
            try {
                const response = await fetch('http://192.168.3.3:18081/check/files/upload/image', {
                    method: 'POST',
                    body: formData,
                });
                if (!response.ok) {
                    throw new Error('图片上传失败!');
                }
                const data = await response.json();
                const userData = data.data;
                this.imageUrl = userData;
                console.log("图片上传成功,地址:", this.imageUrl);
                return this.imageUrl;
            } catch (error) {
                console.error("图片上传失败!", error);
                throw error;
            }
        },

        // 上传表单文本
        // async submiTextData(textData) {
        //   const jsonData = JSON.stringify(textData);
        //   console.log(jsonData);
        //   const response = await fetch('http://127.0.0.1:18080/abnormal/addAbnormal', {
        //     method: 'POST',
        //     headers: {
        //       'Content-Type': 'application/json',
        //     },
        //     body: jsonData,
        //   });
        //   console.log(response);
        //   // return response;
        // },


        // 重置表单数据逻辑
        async resetForm() {
            // 根据表单的ref标签进行重置表单的内容 
            // this.$refs.form.reset();
            const currentTime = await this.initializeTime();
            this.formData = {
                check_type: '灭火器',
                check_number: '',
                check_task_item_one: '',
                check_task_item_two: '',
                check_task_item_three: '',
                check_task_item_four: '',
                check_task_item_five: '',
                check_task_item_six: '',
                check_task_item_seven: '',
                check_task_item_eight: '',
                check_task_item_nine: '',
                check_buliding: '',
                check_floor: '',
                check_description: '',
                check_attachment: null,
                check_staff: '',
                check_department: '',
                check_date: currentTime,
            },
                this.imageUrl = null;
        }
    }
}
</script>